import React, { useEffect, useState } from "react";

import "./ClientesConRuta.scss";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getClientes } from "../Bitacoras/integracion";
import { getRutasByIdClient } from "./integracion";

export default function ClientesConRuta() {
    const [clienteSeleccionado, setClienteSeleccionado] = useState({name:"SUMA TE LLEVA",code:5});
    const [clientes, setClientes] = useState([]);


    const [datos, setDatos] = useState([]);
    useEffect(() => {
        const clientesFunc = async ()=>
        {
           await getClientes(setClientes)
        }
        clientesFunc()
    },[])
    useEffect(()=>
    {
        getRutasByIdClient(setDatos,clienteSeleccionado.code)
    },[clienteSeleccionado])
    return (
        <div className="vista-cliente-rutas">
            <div className="vista-cliente-filtros">
                <div className="grupo-filtro">
                    <label htmlFor="cliente">Cliente</label>
                    <Dropdown
                        id="cliente"
                        value={clienteSeleccionado}
                        onChange={(e) => setClienteSeleccionado(e.value)}
                        options={clientes}
                        placeholder="Seleccione un cliente"
                        className="tamañoFiltro"
                        optionLabel="name"
                        filter
                    />
                </div>
            </div>

            <div className="tabla-scroll-wrapper">
                <DataTable
                    value={datos}
                    stripedRows
                    responsiveLayout="scroll"
                    scrollable
                    scrollHeight="calc(100vh - 170px)"
                    emptyMessage="No se encontraron resultados"
                >
                    <Column field="ID" header="ID del Cliente" />
                    <Column field="CLIENTE" header="Cliente" />
                    <Column field="ID_UNIDAD" header="Unidad" />
                    <Column field="TIPO_UNIDAD" header="Tipo de Unidad" />
                    <Column field="ID_RUTA" header="ID de la Ruta" />
                    <Column field="RUTA" header="Ruta" />
                </DataTable>
            </div>
        </div>
    );
}
